// images of a rich text (BO editor) without an alt get the page title: Google reads it, screen readers too
export const withImageAlt = (html?: string | null, alt?: string | null) => {
  if (!html || !alt) return html ?? ''
  const safe = alt.replace(/&/g, '&amp;').replace(/"/g, '&quot;').replace(/</g, '&lt;')

  return html.replace(/<img\b(?![^>]*\balt=)([^>]*)>/gi, `<img alt="${safe}"$1>`)
}
